import { render, staticRenderFns } from "./PayrollSettings.vue?vue&type=template&id=d11fddfa&lang=pug"
import script from "./PayrollSettings.vue?vue&type=script&lang=js"
export * from "./PayrollSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports